/**
 * Logic for default version selection.
 */
export function useVersion(preference: string | undefined, versions: string[]) {
  return preference ?? (versions.length ? versions[0] : null)
}